import { Component, OnInit } from '@angular/core';
import { BaseDataService, BaseTabsContainer, TabsContainerService, UserService } from 'yt-ng-framework';
import { TrosakDokument } from './trosak-dokument';
import { ActivatedRoute } from '@angular/router';
import { TrosakDokumentView } from './trosak-dokument-view';
// import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'yt-trosak-dokument-tabs',
  templateUrl: './trosak-dokument-tabs.component.html',
  providers: [
    TabsContainerService
]
})
export class TrosakDokumentTabsComponent extends BaseTabsContainer<TrosakDokumentView> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<TrosakDokumentView>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) {
    super(tabsContainerService, activatedRoute, userService);
   }

  ngOnInit() {
    super.ngOnInit();
  }  

}
